import React from "react";
import Meta from "../../components/Meta"
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import about from "../../assets/about.png";
import aboutimg1 from "../../assets/aboutimg1.png";
import aboutimg2 from "../../assets/aboutimg2.png";
import aboutimg3 from "../../assets/aboutimg3.png";
import "../../styles/about.css";

const About = () => {
  return (
    <div>
      <Meta title="Wedevelopers - About" />
      <div className="herobg">
        <Header />
        <section className="container position-relative about-hero">
          <div className="d-flex justify-content-between h-100 about-hero-content">
            <div className="mr-1 w-50 d-flex align-items-center">
              <h2 className="font-heading py-1 lh-small text-uppercase font-weight-bolder text-white">
                solving the global{" "}
                <span style={{ color: "#75e8f0" }}>tech talent shortage.</span>
              </h2>
            </div>
            <div className="about-hero-img position-relative w-60 about-hero-img pt-2">
              <div className="pr-1">
                <img src={aboutimg2} alt="team image" />
              </div>
              <div>
                <img src={aboutimg3} alt="team image" />
              </div>
              <div className="p-1">
                <img src={aboutimg1} alt="team image" />
              </div>
            </div>
          </div>
        </section>
      </div>
      <section className="py-4 container">
        <div className="d-flex align-items-center about-section">
          <div className="w-50 about-section-img mr-1">
            <img src={about} alt="about image" />
          </div>
          <div className="text-center w-50">
            <h3 className="font-heading font-weight-bolder text-black">
              About Us
            </h3>
            <p className="text-black-fade font-normal">
              Wedeveloper is a platform for developers across the globe to
              enhance their skills, get jobs, work on project hereby gaining a
              lot of experience that is needed in the technology world. There is
              a lot of opportunity for developers under this platform as
              developer can decide to either work remotely or relocate depending
              on the requirement of the project.
            </p>
          </div>
        </div>
      </section>
      <section className="py-4 container">
        <div className="d-flex visionmission">
          <div className="text-center">
            <h3 className="font-heading font-weight-bolder text-black">
              Our Mission
            </h3>
            <p className="text-black-fade font-normal">
              At Wedeveloper we are on a mission to build a global community of
              Trusted developers and employers
            </p>
          </div>
          <div className="text-center ml-2">
            <h3 className="font-heading font-weight-bolder text-black">
              Our Vision
            </h3>
            <p className="text-black-fade font-normal">
              To enhance technology in Africa and the whole world bridging the
              gap between the developers and companies making sure that standard
              products are built and the world becomes a better place.
            </p>
          </div>
        </div>
      </section>
      <section className="values container">
        <div className="d-flex justify-content-between p-4 pb-5">
          <h3
            style={{ whiteSpace: "nowrap" }}
            className="font-heading font-weight-bolder text-white mb-0 lh-small pr-5">
            Our Core Values
          </h3>
          <div className="text-center ml-2">
            <p className="text-white font-normal">
              Our core values are to build a positive team and a family spirit,
              to be innovative and excellent, to work smart to be part of the
              solutions the world needs. We are ambitious and we create
              opportunities. We prioritize teamwork and collaboration.
            </p>
          </div>
        </div>
      </section>
      <section className="contactservices">
        <div className="container row justify-content-center">
          <div className="services col-md-8 row">
            <div className="col-md-5">
              <div>
                <i className="fas fa-check"></i>
              </div>
              <h4 className="font-medium">Data Analytics</h4>
              <p>
                We leverage, manage, and analyze large data sets with our big
                data solutions, we use the latest technologies to help analyze
                and extract very useful information to develop various types of
                data management solutions.
              </p>
            </div>
            <div className="col-md-5">
              <div>
                <i className="fas fa-check"></i>
              </div>
              <h4 className="text-white font-medium">App Development</h4>
              <p>
                Our application development services are designed to deliver
                customized solutions for your unique business requirements. Our
                highly talented developers build secure and scalable apps for
                clients in diverse industries
              </p>
            </div>
            <div className="col-md-5">
              <div>
                <i className="fas fa-check"></i>
              </div>
              <h4 className="font-medium">SEO Ranking</h4>
              <p>
                Our team makes sure that the pages that are meant for the public
                can be found by the search engines. We research to find the best
                performing keywords in your industry and assign them to the
                appropriate pages on your website.
              </p>
            </div>
            <div className="col-md-5">
              <div>
                <i className="fas fa-check"></i>
              </div>
              <h4 className="font-medium">Cyber Security</h4>
              <p>
                Our security services provides the expertise to identify and
                prioritize the most sensitive identities in your product. Once
                identified, our team offer design, implementation and project
                management expertise to help attain optimum security posture.
              </p>
            </div>
          </div>
          <div className="contact d-flex flex-column col-md-4 align-items-center justify-content-center mt-2">
            <h3 className="font-subhead text-center lh-small">
              We provide the best digital service
            </h3>
            <a
              href="/contact"
              className="font-normal primary-btn purple-btn px-1 py-50 border-none">
              Contact Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default About;
